import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { Button } from '../ui/Button';

interface IdCellProps {
  id: string;
  length?: number;
  className?: string;
}

export const IdCell: React.FC<IdCellProps> = ({ id, length, className = '' }) => {
  const [copied, setCopied] = useState(false);

  if (!id) {
    return <span className="text-cf-textMuted text-xs">—</span>;
  }

  const handleCopy = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigator.clipboard.writeText(id);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <Button
      type="button"
      variant="ghost"
      size="xs"
      onClick={handleCopy}
      title={`Click to copy full ID: ${id}`}
      className={`w-full min-w-0 flex items-center justify-between gap-1 text-xs font-sans px-1.5 py-0.5 rounded bg-cf-surfaceHover hover:bg-cf-surfaceActive text-cf-textSecondary hover:text-cf-textPrimary border border-cf-border transition-colors group select-none ${className}`}
    >
      <span className="truncate flex-1 text-left min-w-0">{id}</span>
      {copied ? (
        <Check size={12} className="text-cf-success flex-shrink-0" />
      ) : (
        <Copy size={12} className="text-cf-textMuted group-hover:text-cf-textPrimary transition-colors flex-shrink-0" />
      )}
    </Button>
  );
};
